const questions = [{
  answers: [{
    title: 'AIRvive™ suoristusrauta',
    id: 'A1',
  }, {
    title: 'AIRvive™ 2-in-1-ilmakiharrin',
    id: 'A2',
  }, {
    title: 'AIRvive™ pyörivä kiharrin',
    id: 'A3',
  }, {
    title: 'AIRvive™ BLDC- hiustenkuivain',
    id: 'A4',
  }],
  id: 'A',
  rightAnswer: 'A1',
  title: 'Kerro millä SINÄ kesytät oman tyylisi ja voita oma AIRvive™‑tuotteesi!',
  embedId: '3yF8imMYnnc',
}];

export default questions;
